export default __webpack_public_path__ + "static/media/date_icon.3368140e.svg";